import { createReactWrapper } from '../create-react-wrappers';
import { applyPolyfills, defineCustomElements } from '@iress/components/loader';
applyPolyfills().then(function () {
    defineCustomElements(window);
});
// IressTabContainer
import { TabContainerLayout, } from './component.types';
;
var IressTabContainer = createReactWrapper('iress-tab-container', false);
IressTabContainer.displayName = 'IressTabContainer';
IressTabContainer.Layout = TabContainerLayout;
export { IressTabContainer };
// END IressTabContainer
// IressTabPanel
import { TabPanelVRTState, } from './component.types';
;
var IressTabPanel = createReactWrapper('iress-tab-panel', false);
IressTabPanel.displayName = 'IressTabPanel';
IressTabPanel.VRTState = TabPanelVRTState;
export { IressTabPanel };
// END IressTabPanel
// IressTabButton
import { TabButtonVRTState, } from './component.types';
;
var IressTabButton = createReactWrapper('iress-tab-button', false);
IressTabButton.displayName = 'IressTabButton';
IressTabButton.VRTState = TabButtonVRTState;
export { IressTabButton };
// END IressTabButton
// IressForm
var IressForm = createReactWrapper('iress-form', false);
IressForm.displayName = 'IressForm';
export { IressForm };
// END IressForm
// IressField
var IressField = createReactWrapper('iress-field', false);
IressField.displayName = 'IressField';
export { IressField };
// END IressField
// IressInput
import { TextFieldType, InputWidth, InputMode, InputVRTState, } from './component.types';
;
var IressInput = createReactWrapper('iress-input', false);
IressInput.displayName = 'IressInput';
IressInput.Type = TextFieldType;
IressInput.Width = InputWidth;
IressInput.InputMode = InputMode;
IressInput.VRTState = InputVRTState;
export { IressInput };
// END IressInput
// IressCheckbox
import { CheckboxVRTState, } from './component.types';
;
var IressCheckbox = createReactWrapper('iress-checkbox', false);
IressCheckbox.displayName = 'IressCheckbox';
IressCheckbox.VRTState = CheckboxVRTState;
export { IressCheckbox };
// END IressCheckbox
// IressCheckboxGroup
var IressCheckboxGroup = createReactWrapper('iress-checkbox-group', false);
IressCheckboxGroup.displayName = 'IressCheckboxGroup';
export { IressCheckboxGroup };
// END IressCheckboxGroup
// IressRadio
import { RadioVRTState, } from './component.types';
;
var IressRadio = createReactWrapper('iress-radio', false);
IressRadio.displayName = 'IressRadio';
IressRadio.VRTState = RadioVRTState;
export { IressRadio };
// END IressRadio
// IressRadioGroup
import { RadioGroupLayout, } from './component.types';
;
var IressRadioGroup = createReactWrapper('iress-radio-group', false);
IressRadioGroup.displayName = 'IressRadioGroup';
IressRadioGroup.Layout = RadioGroupLayout;
export { IressRadioGroup };
// END IressRadioGroup
// IressButton
import { ButtonMode, ButtonType, ButtonSlot, ButtonVRTState, } from './component.types';
;
var IressButton = createReactWrapper('iress-button', false);
IressButton.displayName = 'IressButton';
IressButton.Mode = ButtonMode;
IressButton.Type = ButtonType;
IressButton.Slot = ButtonSlot;
IressButton.VRTState = ButtonVRTState;
export { IressButton };
// END IressButton
// IressBadge
import { BadgeMode, } from './component.types';
;
var IressBadge = createReactWrapper('iress-badge', false);
IressBadge.displayName = 'IressBadge';
IressBadge.Mode = BadgeMode;
export { IressBadge };
// END IressBadge
// IressPanel
import { PanelPadding, } from './component.types';
;
var IressPanel = createReactWrapper('iress-panel', true);
IressPanel.displayName = 'IressPanel';
IressPanel.Padding = PanelPadding;
export { IressPanel };
// END IressPanel
// IressContainer
var IressContainer = createReactWrapper('iress-container', true);
IressContainer.displayName = 'IressContainer';
export { IressContainer };
// END IressContainer
// IressCol
import { ColOffset, ColSize, ColAlignSelf, } from './component.types';
;
var IressCol = createReactWrapper('iress-col', true);
IressCol.displayName = 'IressCol';
IressCol.Offset = ColOffset;
IressCol.Size = ColSize;
IressCol.AlignSelf = ColAlignSelf;
export { IressCol };
// END IressCol
// IressRow
import { RowAlignItems, RowJustifyContent, RowGutter, } from './component.types';
;
var IressRow = createReactWrapper('iress-row', true);
IressRow.displayName = 'IressRow';
IressRow.AlignItems = RowAlignItems;
IressRow.JustifyContent = RowJustifyContent;
IressRow.Gutter = RowGutter;
export { IressRow };
// END IressRow
// IressValidationMessage
import { SystemValidationStatus, } from './component.types';
;
var IressValidationMessage = createReactWrapper('iress-validation-message', false);
IressValidationMessage.displayName = 'IressValidationMessage';
IressValidationMessage.Status = SystemValidationStatus;
export { IressValidationMessage };
// END IressValidationMessage
// IressValidationSummary
var IressValidationSummary = createReactWrapper('iress-validation-summary', false);
IressValidationSummary.displayName = 'IressValidationSummary';
export { IressValidationSummary };
// END IressValidationSummary
// IressAlert
import { HeadingLevel, } from './component.types';
;
var IressAlert = createReactWrapper('iress-alert', false);
IressAlert.displayName = 'IressAlert';
IressAlert.Status = SystemValidationStatus;
IressAlert.HeadingLevel = HeadingLevel;
export { IressAlert };
// END IressAlert
// IressIcon
import { IconSet, IconFlip, IconRotate, IconSpin, } from './component.types';
;
var IressIcon = createReactWrapper('iress-icon', false);
IressIcon.displayName = 'IressIcon';
IressIcon.Set = IconSet;
IressIcon.Flip = IconFlip;
IressIcon.Rotation = IconRotate;
IressIcon.Spin = IconSpin;
export { IressIcon };
// END IressIcon
// IressInline
import { InlineGutter, InlineAlign, } from './component.types';
;
var IressInline = createReactWrapper('iress-inline', false);
IressInline.displayName = 'IressInline';
IressInline.Gutter = InlineGutter;
IressInline.Align = InlineAlign;
export { IressInline };
// END IressInline
// IressText
import { TextElement, TextVariant, TextAlign, } from './component.types';
;
var IressText = createReactWrapper('iress-text', false);
IressText.displayName = 'IressText';
IressText.Element = TextElement;
IressText.Variant = TextVariant;
IressText.Align = TextAlign;
export { IressText };
// END IressText
// IressStack
import { StackGutter, } from './component.types';
;
var IressStack = createReactWrapper('iress-stack', true);
IressStack.displayName = 'IressStack';
IressStack.Gutter = StackGutter;
export { IressStack };
// END IressStack
// IressThemeSwitcher
var IressThemeSwitcher = createReactWrapper('iress-theme-switcher', true);
IressThemeSwitcher.displayName = 'IressThemeSwitcher';
export { IressThemeSwitcher };
// END IressThemeSwitcher
// IressPlaceholder
var IressPlaceholder = createReactWrapper('iress-placeholder', true);
IressPlaceholder.displayName = 'IressPlaceholder';
export { IressPlaceholder };
// END IressPlaceholder
export * from './component.types';
//# sourceMappingURL=index.js.map